import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { PageTitle } from "@/admin/AdminLayout";

export default function LanguagesAdmin() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ code: "", name: "", native_name: "" });
  const refresh = () => api.get("/admin/languages").then((r) => setList(r.data));
  useEffect(() => { refresh(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/languages", form); toast.success(`${form.name} added — now available on every artwork`); setForm({ code: "", name: "", native_name: "" }); refresh(); }
    catch (err) { toast.error(errorText(err)); }
  };
  const remove = async (l) => {
    if (!window.confirm(`Remove ${l.name}? Its texts and audio links on all artworks will be removed.`)) return;
    try { await api.delete(`/admin/languages/${l.code}`); refresh(); } catch (err) { toast.error(errorText(err)); }
  };

  return (
    <div data-testid="admin-languages-page">
      <PageTitle>Languages</PageTitle>
      <form onSubmit={add} className="grid sm:grid-cols-[100px_1fr_1fr_auto] gap-3 border border-[var(--line)] p-4 mb-8" data-testid="language-add-form">
        <input className="field" placeholder="Code (de)" maxLength={3} required value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} data-testid="language-code" />
        <input className="field" placeholder="Name (German)" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="language-name" />
        <input className="field" placeholder="Native name (Deutsch)" value={form.native_name} onChange={(e) => setForm({ ...form, native_name: e.target.value })} data-testid="language-native-name" />
        <button type="submit" className="btn-accent px-5 py-3 text-xs" data-testid="language-add-submit">Add language</button>
      </form>
      <table className="w-full admin-table text-sm" data-testid="language-table">
        <thead><tr><th>Code</th><th>Name</th><th>Native</th><th></th></tr></thead>
        <tbody>{list.map((l) => (
          <tr key={l.code} data-testid={`language-row-${l.code}`}>
            <td className="font-bold uppercase">{l.code}</td><td>{l.name}</td><td className="text-[var(--muted)]">{l.native_name}</td>
            <td className="text-right"><button type="button" onClick={() => remove(l)} className="ctrl !w-9 !h-9 text-[var(--muted)] hover:text-accent" aria-label="Remove" data-testid={`language-delete-${l.code}`}><Trash2 size={16} /></button></td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  );
}
